
import AppNavItemDropdownPortalContainer from '@components/common/navs/app-nav/nav-item-dropdown/AppNavItemDropdownPortalContainer';
import ScrollRestore from '@components/common/scroll-restore/ScrollRestore';
import PopupContainer from '@components/widgets/popup/PopupContainer';
import SiteLoader from '@components/widgets/site-loader/SiteLoader';
import ErrorBoundary from '@errors/error-boundary/ErrorBoundary';
import SMSPostPopupContainer from '@features/social-media/single/post-popup/SMSPostPopupContainer';
import DashboardLayout from '@layouts/dashboard/DashboardLayout';

import './MainLayout.sass';

function MainLayout() {
    return (
        <main className="app">
            <ErrorBoundary>
                <PopupContainer />
                <SMSPostPopupContainer />
                <AppNavItemDropdownPortalContainer />

                <div className="app-clip"></div>
                <ScrollRestore />

                <DashboardLayout />

                <SiteLoader />
            </ErrorBoundary>
        </main>
    );
}

export default MainLayout;
